// extracted by mini-css-extract-plugin
export default {"page":"KW-z","cartModal":"LW-z","checkout":"MW-z","placeholder":"NW-z","account":"OW-z"};